<template>
    <div class="flex items-center item-avatar">
      <vs-avatar size="40px"
        :src="params.data.user && params.data.user.media.length ? params.data.user.media[0].url : ''"/>
        <img
          v-if="params.data.blocked"
          src="@/assets/images/pages/settings/users/blocked.svg"
          class="absolute avatar-status" />
        <img
          v-else-if="params.data.status === 1"
          src="@/assets/images/pages/settings/users/active.svg"
          class="absolute avatar-status" />
        <img
          v-else
          src="@/assets/images/pages/settings/users/inactive.svg"
          class="absolute avatar-status" />

        <div class="ml-3 space-y-2">
          <div class="font-medium text-lg">
            {{ params.data.user_name }}
          </div>
          <div class="users-email">
            {{ params.data.email }}
          </div>
        </div>
    </div>
</template>

<script>
export default {
}
</script>

<style scoped lang="scss">
/deep/ .vs-avatar--con-img {
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.item-avatar {
  line-height: normal !important;
}

.avatar-status {
  left: 50px;
  top: 28px;
}

.users-email {
  margin-top: 0 !important;
  font-size: 12px !important;
  font-weight: 500 !important;
}
</style>